import { render, staticRenderFns } from "./NRNVisa.vue?vue&type=template&id=983c6a1e&"
import script from "./NRNVisa.vue?vue&type=script&lang=js&"
export * from "./NRNVisa.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports